<div *ngIf="noSearchResults">
    <p>
        😞 No results for <strong>{{ query }}</strong>
    </p>
</div>
